
export const baseURL = process.env.VUE_APP_API_URL;
export const websocketURL = process.env.VUE_APP_API_URL_WS;
